import { render, staticRenderFns } from "./PlanAdd.vue?vue&type=template&id=50721e8c&scoped=true&"
import script from "./PlanAdd.vue?vue&type=script&lang=js&"
export * from "./PlanAdd.vue?vue&type=script&lang=js&"
import style0 from "./PlanAdd.vue?vue&type=style&index=0&id=50721e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50721e8c",
  null
  
)

export default component.exports